import { type ChangeEvent, type FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Text, TextVariant } from '@enbw/ui-react'
import styles from './styles.module.scss'

const DEFAULT_PAGE_SIZE_OPTIONS = [10, 20, 50, 100] as const

type PageSizeSelectorProps = {
  readonly itemsPerPage: number
  readonly pageSizeOptions?: readonly number[]
  readonly onPageSizeChange: (pageSize: number) => void
}

export const PageSizeSelector: FC<PageSizeSelectorProps> = ({ itemsPerPage, pageSizeOptions = DEFAULT_PAGE_SIZE_OPTIONS, onPageSizeChange }) => {
  const { t } = useTranslation()

  const handleChange = (event: ChangeEvent<HTMLSelectElement>): void => {
    onPageSizeChange(Number.parseInt(event.target.value, 10))
  }

  return (
    <div className={styles.pageSizeSelector}>
      <label htmlFor="page-size-select">
        <Text variant={TextVariant.BodyExtraSmallWeighted}>{t('pagination.itemsPerPage')}</Text>
      </label>
      <select id="page-size-select" value={itemsPerPage} onChange={handleChange}>
        {pageSizeOptions.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>
    </div>
  )
}
